<template>
  <div
    class="modal-container"
    v-if="showItem"
    :class="{'active': active}"
  >
    <div class="modal">
      <div class="modal-body">
        <slot name="modal-body" />
      </div>
      <div class="modal-footer">
        <slot name="modal-footer" />
      </div>
    </div>
    <div
      class="modal-outside"
      @click="close"
    />
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
      showItem: false,
      active: false,
      activeCloseBtn: false,
    };
  },
  methods: {
    close () {
      this.$emit('close');
    },
    showModal () {
      this.showItem = true;
      document.body.style.overflow = 'hidden';

      setTimeout(() => { this.active = true; }, 250);
      setTimeout(() => { this.activeCloseBtn = true; }, 500);
    },
    hideModal () {
      this.activeCloseBtn = false;
      document.body.style.overflow = '';
      setTimeout(() => { this.active = false; }, 250);
      setTimeout(() => { this.showItem = false; }, 750);
    },
  },
  watch: {
    show () {
      if (this.show) {
        this.showModal();
      } else {
        this.hideModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  z-index: 1;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  transition: all ease .1s;

  &:before {
    content: '';
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background-color: rgba(39, 49, 66, .5);
    opacity: 0;
    transition: opacity ease 1s;
  }

  .modal-outside {
    position: fixed;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .modal {
    position: fixed;
    z-index: 3;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    background-color: #fff;
    border-radius: 0;
    transition: transform ease .5s;
    transform: translateY(100%);

    .modal-header{
      display: flex;
      font-size: 14px;
      min-height: 20px;
      margin-bottom: 20px;
      .modal-title, .modal-close, .modal-select-button{
        flex: 1;
        text-align: left;
      }
      .modal-title{
        font-weight: 500;
        text-align: center;
        padding: 0 50px;
      }
      .modal-close{
        color: rgb(255, 80, 67);
        max-width: 50px;
        position: absolute;
        left: 20px;
      }
      .modal-select-button{
        position: absolute;
        text-align: right;
        color: rgb(242, 122, 26);
        max-width: 50px;
        right: 20px;
      }
    }

    @media screen and (max-height: 550px) {
      top: 50px;
      .modal-body {
        overflow: hidden;
        overflow-y: auto;
        height: 100%;
      }
      .modal-footer {
        background-color: #ffffff;
      }
    }
  }

  &.active {
    &:before {
      opacity: 1;
    }

    .modal {
      transform: translateY(0);
    }
  }
}
</style>
